import { QuerifyService } from '@core/services/querify.service';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { Mutations } from './mutations';
import { Queries } from './queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./mutations";
import * as i3 from "./queries";
import * as i4 from "../../services/querify.service";
var GroupsApi = /** @class */ (function () {
    function GroupsApi(apollo, mutations, queries, querify) {
        this.apollo = apollo;
        this.mutations = mutations;
        this.queries = queries;
        this.querify = querify;
    }
    GroupsApi.prototype.save = function (group) {
        return this.apollo.mutate({
            mutation: this.mutations.createGroup(),
            variables: {
                input: group
            }
        });
    };
    GroupsApi.prototype.update = function (id, group) {
        return this.apollo.mutate({
            mutation: this.mutations.updateGroup(),
            variables: {
                id: id,
                input: group
            }
        });
    };
    GroupsApi.prototype.search = function (query, options) {
        options = this.querify.transformOptions(query, options);
        return this.apollo
            .query({
            query: this.queries.getGroups(),
            variables: options
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['groups'];
        }));
    };
    GroupsApi.prototype.searchOne = function (id) {
        return this.apollo
            .query({
            query: this.queries.getGroup(),
            variables: { id: id }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['group'];
        }));
    };
    GroupsApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GroupsApi_Factory() { return new GroupsApi(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Mutations), i0.ɵɵinject(i3.Queries), i0.ɵɵinject(i4.QuerifyService)); }, token: GroupsApi, providedIn: "root" });
    return GroupsApi;
}());
export { GroupsApi };
